import { ReactNode } from 'react';
import { FelaCSS, TButtonSize, TButtonTheme, TSizeValues, colors } from '@bridebook/ui';
import getSizeValue from '../../../../fela-utils/get-size-value';

interface IStyleProps {
  theme?: TButtonTheme;
  size?: TButtonSize;
  disabled?: boolean;
  equalPadding?: boolean;
  children?: ReactNode;
  direction: string;
  w?: TSizeValues;
  h?: TSizeValues;
  rounded?: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
  contentWrap: FelaCSS;
  chevronWrap: FelaCSS;
}

const styles = ({ direction, w, h, rounded }: IStyleProps): IStyles => {
  const width: FelaCSS = w ? getSizeValue('width', w) : { width: 'auto' };
  const height: FelaCSS = h ? getSizeValue('height', h) : { height: 'auto' };

  const getTransform = (direction) => {
    if (direction === 'right') return 'rotate(270deg)';
    if (direction === 'left') return 'rotate(90deg)';
    if (direction === 'up') return 'rotate(180deg)';
    return;
  };

  const getLeftPosition = (direction) => {
    if (direction === 'right') return '3%';
    if (direction === 'left') return '-3%';
    if (direction === 'up') return 'unset';
    return;
  };

  return {
    wrapper: {
      ...width,
      ...height,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      ...(rounded
        ? {
            borderRadius: '100px',
          }
        : {}),
      ':hover': {
        ...(rounded
          ? {
              borderRadius: '100px',
              border: `2px solid ${colors.space15}`,
              boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.4)',
            }
          : {
              border: `1px solid ${colors.space15}`,
              borderRadius: '4px',
            }),
      },
      ':active': {
        backgroundColor: colors.space04,
      },
    },

    contentWrap: {
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },

    chevronWrap: {
      transform: getTransform(direction),
      left: getLeftPosition(direction),
    },
  };
};

export default styles;
